export default function AboutSection() {
  return (
    <section className="px-4 md:px-6 py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              Unlock Your Edge, Achieve Peak Performance
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              Abstract Data focuses on delivering high-performance and flexible
              Reserved GPUaaS, helping enterprises and research teams break
              through technical bottlenecks and create unlimited possibilities.
            </p>
            <ul className="mt-6 space-y-3 text-foreground-700">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs" />
                </span>
                Flexible choices to meet diverse needs
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs" />
                </span>
                Top-tier hardware, stable and high-speed
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs" />
                </span>
                Professional support to ensure smooth operations
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs" />
                </span>
                Cost-effective, maximizing return on investment
              </li>
            </ul>
            <a
              href="#features"
              className="mt-8 inline-flex px-7 py-3 text-base font-semibold whitespace-nowrap rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 cursor-pointer transition-colors"
            >
              Learn more
            </a>
          </div>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://images.unsplash.com/photo-1729964079476-595fd4f7d627?ixid=M3w0MzUxNjF8MHwxfHNlYXJjaHwxOXx8c2VydmVyJTIwcmFja3N8ZW58MHx8fHwxNzUyMTU1NzEzfDA&ixlib=rb-4.1.0&orientation=portrait&fit=crop&crop=entropy%2Cfaces&auto=format%2Ccompress&w=1280"
              alt="Server rack infrastructure"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}